/**
 * Pure UTC month-grid arithmetic — no calendar library, matching this
 * codebase's existing convention (`formatDate` wraps `Intl.DateTimeFormat`,
 * and that is the only date tooling used anywhere in this app). Every date
 * here is UTC midnight, matching the backend's wall-clock-as-UTC
 * simplification for calendar occurrences.
 */

export function startOfMonthUTC(date: Date): Date {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
}

export function addMonthsUTC(date: Date, delta: number): Date {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + delta, 1));
}

export function toDateKey(date: Date | string): string {
  return (typeof date === 'string' ? date : date.toISOString()).slice(0, 10);
}

/** A Sunday-starting 6-row grid covering `viewDate`'s month, with lead-in
 *  and lead-out days from the adjacent months so every week is full. */
export function buildMonthGrid(viewDate: Date): Date[] {
  const monthStart = startOfMonthUTC(viewDate);
  const gridStart = new Date(monthStart);
  gridStart.setUTCDate(gridStart.getUTCDate() - gridStart.getUTCDay());

  return Array.from({ length: 42 }, (_, i) => {
    const day = new Date(gridStart);
    day.setUTCDate(gridStart.getUTCDate() + i);
    return day;
  });
}

/** The `[from, to]` range to request occurrences for — the full 42-day grid,
 *  not just the calendar month, since lead-in/lead-out days render too. */
export function gridRange(viewDate: Date): { from: string; to: string } {
  const days = buildMonthGrid(viewDate);
  const first = days.at(0)!;
  const last = days.at(-1)!;
  return { from: toDateKey(first), to: toDateKey(last) };
}
